/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import jsonExport from "jsonexport/dist";

import { API } from "aws-amplify";
import { useSearchableList } from "../../../dataProvider/useSearchableList";

import {
  Box,
  Card,
  Divider,
  Grid,
  Hidden,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";

import {
  BulkActionsToolbar,
  BulkExportButton,
  Confirm,
  CreateButton,
  Datagrid,
  DateField,
  DateInput,
  downloadCSV,
  EditButton,
  FilterButton,
  FunctionField,
  ListContextProvider,
  NumberField,
  RefreshButton,
  SelectInput,
  SimpleList,
  TextField,
  Title,
  TopToolbar,
  useListContext,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";
import { FilterContext, FilterForm } from "ra-ui-materialui";
import { Form } from "react-final-form";

import { ChevronRightIcon, ExportIcon } from "../../../components/common/iconography";
import { Empty } from "../../../components/common/Empty";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { SearchField } from "../../../components/common/SearchField";
import { Pagination } from "../../../components/Pagination";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { accountNameRenderer } from "../../../components/common/AccountNameRenderer";
import { QuickFilter } from "../../../components/common/QuickFilter";

import {
  isSubscriptionDisabled,
  logError,
  logHistory,
} from "../../../utils/appUtils";
import { InvoiceStatus, ResourceType } from "../../../utils/constants";
import { exportCustomField } from "../../../utils/utils";
import {
  fetchTriggerEnabled,
  getTriggerEnabled,
} from "../../../utils/zapierUtils";
import { ChargeEventChoices } from "../accounts/chargeRules/chargeRuleConstants";

import { InvoicePeak } from "./InvoicePeak";
import { InvoiceStatusIcon } from "./InvoiceStatusIcon";
import { MarkPaidButton, BulkMarkPaidButton } from "./MarkPaidButtons";
import { BulkSendButton } from "./SendInvoiceButtons";
import {
  getMemo,
  getPoNumber,
  getServiceDate,
  updateLambdaTransform,
} from "./InvoiceUtils";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    transition: theme.transitions.create(["all"], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginTop: 0,
  },
  bulkActions: {
    // [classes.bulkActions] remove to restore original behavior
    marginTop: -theme.spacing(8),
    transition: theme.transitions.create("margin-top"),
  },
  totals: {
    marginLeft: theme.spacing(2),
  },
}));

const useToolbarStyles = makeStyles(
  (theme) => ({
    toolbar: {
      justifyContent: "space-between",
      alignItems: "flex-start",
      paddingRight: 0,
      [theme.breakpoints.up("xs")]: {
        paddingLeft: 0,
      },
      [theme.breakpoints.down("xs")]: {
        paddingLeft: theme.spacing(2),
      },
    },
    leftControlsXs: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        paddingRight: theme.spacing(2),

        // Make FilterForm inputs span full width on mobile
        "& [class*='RaFilterForm-form']": {
          width: "100%",
        },
        "& .filter-field": {
          width: "100%",
          flexBasis: "100%",
          flexGrow: 1,
        },
        // Remove the trailing spacer that prevents full-width controls
        "& .filter-field > div:last-child": {
          display: "none",
        },
      },
    },
  }),
  { name: "InboundListToolbar" },
);

const tabs = [
  { id: InvoiceStatus.NEW, name: "Draft", showSmall: true },
  { id: InvoiceStatus.PENDING, name: "Pending", showSmall: true },
  { id: InvoiceStatus.PAID, name: "Completed", showSmall: true },
];

const exporter = (invoices, setinvoices, notify, onUnselectItems) => {
  // BulkExportButton.dataProvider.getMany(), returns full invoice records, including lineItems.items
  const invoicesForExport = [];
  const customHeaderMap = new Map();

  const handleUndefined = (item) => (item ? item : "");

  try {
    invoices.forEach((invoice) => {
      invoice.lineItems.items.forEach((element) => {
        const invoiceLineItem = {
          InvoiceNo: invoice.invoiceNumber,
          Customer: invoice.accountName,
          InvoiceDate: new Date(invoice.createdAt).toLocaleDateString(),
          DueDate: new Date(invoice.dueDate).toLocaleDateString(),
          Terms: invoice.paymentTerms,
          Memo: getMemo(invoice),
          Item: element.service?.name || "",
          ItemDescription: handleUndefined(element.serviceNote),
          ItemQuantity: element.quantity,
          ItemRate: element.unitCost,
          ItemAmount: element.amount,
          ItemTaxCode: element.taxRate.taxCode,
          ItemTaxAmount: element.itemTax,
          Currency: "USD",
          ServiceDate: getServiceDate(invoice, element),
        };

        // OPTIONAL VALUES
        invoiceLineItem.poNumber = getPoNumber(invoice, element);
        if (invoice.customFields?.length > 0) {
          invoice.customFields.forEach((field) => {
            exportCustomField(field, invoiceLineItem, customHeaderMap);
          });
        }

        invoicesForExport.push(invoiceLineItem);
      });
    });

    jsonExport(
      invoicesForExport,
      {
        rename: [
          "InvoiceNo",
          "Customer",
          "InvoiceDate",
          "DueDate",
          "Terms",
          "Memo",
          "Item(Product/Service)",
          "ItemDescription",
          "ItemQuantity",
          "ItemRate",
          "ItemAmount",
          "ItemTaxCode",
          "ItemTaxAmount",
          "Currency",
          "ServiceDate",
          // ...customHeaderMap.keys()
        ], // order fields in the export
      },
      (err, csv) => {
        downloadCSV(csv, `invoices_${new Date().toLocaleDateString()}`); // download as 'invoices_date.csv` file
      },
    );
  } catch (err) {
    logError("invoices:InvoiceList:exporter", err, notify);
  } finally {
    setinvoices(invoices);
    onUnselectItems();
  }
};

const handlePendingUpdate = async (
  invoices,
  setinvoices,
  setSaving,
  notify,
  redirect,
  refresh,
) => {
  setSaving(true);
  debugger;

  try {
    const invoiceUpdateList = updateLambdaTransform(invoices);

    const response = await API.post("transREST", "/invoiceUpdateBulk", {
      body: {
        invoiceUpdateList: invoiceUpdateList,
        user: window.appUser.email,
        reloadYardId: window.appUser.reloadYardId,
      },
    });
    if (response.error) throw response.error;

    invoiceUpdateList.forEach((invoice) => {
      const historyNote = {
        text: `Invoice Exported.`,
        parentId: invoice.id,
        parentType: ResourceType.INVOICE,
      };
      logHistory(historyNote);
    });

    notify("Invoices updated successfully.", "info");
  } catch (err) {
    logError("invoices:InvoiceList:handlePendingUpdate", err, notify, redirect);
  } finally {
    setSaving(false);
    setinvoices([]);
    refresh();
  }
};

const InvoiceSearchField = (props) => {
  const { label, alwaysOn } = props;
  const { displayedFilters, filterValues, setFilters } = useListContext(props);

  const handleSearch = (value) => {
    debugger;
    if (value) {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(
        {
          ...nextFilterValues,
          or: [
            { accountName: { matchPhrasePrefix: `${value}` } },
            { invoiceNumber: { matchPhrasePrefix: `.*${value}.*` } },
            { invoiceNumber: { wildcard: `*${value}*` } },
            { poNumbers: { matchPhrasePrefix: `${value}` } },
            { poNumbers: { wildcard: `*${value}*` } },
            { railCarNumbers: { matchPhrasePrefix: `${value}` } },
            { railCarNumbers: { wildcard: `*${value}*` } },
            { pickupNumbers: { matchPhrasePrefix: `${value}` } },
            { pickupNumbers: { wildcard: `*${value}*` } },
            { customFields: { matchPhrasePrefix: `${value}` } },
            { customFields: { wildcard: `*${value}*` } },
            { paymentReferences: { matchPhrasePrefix: `${value}` } },
            { paymentReferences: { wildcard: `*${value}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(nextFilterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (mdDown, tabValue) => {
  return [
    <InvoiceSearchField label="Search" tabValue={tabValue} alwaysOn />,
    tabs[tabValue].id === InvoiceStatus.PENDING ? (
      <QuickFilter
        source="overDue"
        label="Over Due"
        defaultValue={{ eq: true }}
      />
    ) : null,
    <SelectInput
      source="event.eq"
      label="Event"
      variant="outlined"
      choices={ChargeEventChoices}
      allowEmpty
      resettable
    />,
    <DateInput
      source="createdAt.lte"
      label="Issued Before..."
      variant="outlined"
      resettable
      onKeyPress={(event) => event.preventDefault()}
    />,
    <DateInput
      source="createdAt.gte"
      label="Issued After..."
      variant="outlined"
      resettable
      onKeyPress={(event) => event.preventDefault()}
    />,
  ].filter(Boolean);
};

const BulkListActions = ({ tabIndex, ...props }) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const refresh = useRefresh();
  const [saving, setSaving] = useState(false);
  const [invoices, setinvoices] = useState([]);
  const { onUnselectItems } = useListContext();
  const [exportedFromTab, setExportedFromTab] = useState(null);
  const [isSyncEnabled, setIsSyncEnabled] = useState(
    getTriggerEnabled("invoiceCreated"),
  );

  useEffect(() => {
    const checkSyncEnabled = async () => {
      const triggerEnabled = await fetchTriggerEnabled("invoiceCreated");
      setIsSyncEnabled(triggerEnabled);
    };
    checkSyncEnabled();
  }, []);

  const handleExport = (data) => {
    // Always remember which tab the export came from so we can show the
    // "Advance Confirmation" prompt when exporting Draft invoices.
    setExportedFromTab(tabs[tabIndex].id);
    exporter(data, setinvoices, notify, onUnselectItems);
  };

  return (
    <>
      <Confirm
        isOpen={
          invoices?.length > 0 &&
          tabs[tabIndex].id === InvoiceStatus.NEW &&
          exportedFromTab === InvoiceStatus.NEW
        }
        loading={saving}
        title="Advance Confirmation"
        content="Advance exported Invoices to PENDING status?"
        onConfirm={() =>
          handlePendingUpdate(
            invoices,
            setinvoices,
            setSaving,
            notify,
            redirect,
            refresh,
          )
        }
        onClose={() => setinvoices([])}
      />
      {!isSyncEnabled && tabs[tabIndex].id !== InvoiceStatus.PAID ? (
        <BulkMarkPaidButton {...props} color="default" />
      ) : null}
      <BulkSendButton {...props} color="default" />
      <BulkExportButton
        {...props}
        exporter={(data) => handleExport(data)}
        color="default"
        icon={<ExportIcon />}
      />
    </>
  );
};

const InvoiceListToolbar = (props) => {
  const {
    filters,
    actions,
    selectedAccountId,
    onAccountChange,
    xsDown,
    ...rest
  } = props;
  const classes = useToolbarStyles(props);

  return Array.isArray(filters) ? (
    <FilterContext.Provider value={filters}>
      <Toolbar className={classes.toolbar}>
        <Box
          display="flex"
          alignItems="flex-start"
          flexWrap="wrap"
          flexDirection={xsDown ? "column" : "row"}
          width={xsDown ? "100%" : undefined}
          className={xsDown ? classes.leftControlsXs : undefined}
        >
          <Form
            key={selectedAccountId || "account-all"}
            onSubmit={() => {}}
            initialValues={{ accountId: selectedAccountId || "" }}
            keepDirtyOnReinitialize
            render={() => (
              <Box
                mt={1}
                mr={xsDown ? 0 : 2}
                width={xsDown ? "100%" : undefined}
              >
                <AccountDropDown
                  source="accountId"
                  label="Account"
                  alwaysOn
                  helperText={false}
                  skipInvoice={true}
                  onAccountChange={onAccountChange}
                />
              </Box>
            )}
          />
          <FilterForm />
        </Box>
        <span />
        {actions &&
          React.cloneElement(actions, {
            ...rest,
            filters, // IMPORTANT: FilterButton expects an array
            ...actions.props,
          })}
      </Toolbar>
    </FilterContext.Provider>
  ) : null;
};

const ListActions = (props) => {
  const { xsDown, basePath } = props;

  return !xsDown ? (
    <TopToolbar>
      <FilterButton />
      <CreateButton basePath={basePath} disabled={isSubscriptionDisabled()} />
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

const getSessionTab = () => {
  const sessionTab = Number(sessionStorage.getItem(`InvoicesTab`));
  if (sessionTab && tabs[sessionTab]) {
    return sessionTab;
  }
  return 0; // Default to the first visible tab if the sessionTab is not valid
};

const getSortByWithScope = (selectedAccountId) => {
  const key = selectedAccountId
    ? "invoiceByAccountByActiveByStatusByDate"
    : "invoiceByActiveByStatusByDateByAccount";
  return `{"key":"${key}", "search":"dueDate"}`;
};

const getDefaultFilterWithScope = (tabIndex, selectedAccountId) => {
  if (selectedAccountId) {
    return {
      accountId: selectedAccountId,
      activeStatusDueDate: {
        beginsWith: {
          active: "true",
          status: tabs[tabIndex].id,
        },
      },
    };
  }

  return {
    reloadYardId: window.appUser.reloadYardId,
    activeStatusDueDateAccountName: {
      beginsWith: {
        active: "true",
        status: tabs[tabIndex].id,
      },
    },
  };
};

const getDefaultSearchFilterWithScope = (tabValue, selectedAccountId) => {
  if (selectedAccountId) {
    return {
      accountId: { eq: selectedAccountId },
      active: { eq: "true" },
      status: { eq: tabs[tabValue].id },
    };
  }

  return {
    reloadYardId: { eq: window.appUser?.reloadYardId },
    active: { eq: "true" },
    status: { eq: tabs[tabValue].id },
  };
};

export const InvoiceList = (props) => {
  const classes = useStyles();
  const mdDown = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [tabIndex, setTabIndex] = useState(getSessionTab());
  const reloadYardId = window.appUser?.reloadYardId;
  const accountStorageKey = `${props.resource}_${reloadYardId}_accountId`;
  const storedAccountId = localStorage.getItem(accountStorageKey);
  const [selectedAccountId, setSelectedAccountId] = useState(
    storedAccountId || null,
  );

  const [defaultFilter, setDefaultFilter] = useState(() =>
    getDefaultFilterWithScope(tabIndex, selectedAccountId),
  );
  const [defaultSearchFilter, setDefaultSearchFilter] = useState(() =>
    getDefaultSearchFilterWithScope(tabIndex, selectedAccountId),
  );
  // Include key & search to display default sort order.
  const defaultSort = {
    field: getSortByWithScope(selectedAccountId),
    order: "DESC",
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = Number(
    localStorage.getItem(`${props.resource}_perPage`),
  );
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? sessionPerPage : 10,
  );

  const listContext = useSearchableList({
    ...props,
    defaultTitle: "Invoices",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
    resource: "invoices",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
  }, [listContext?.filter]);

  const applyScopedDefaults = (nextTabIndex, nextAccountId) => {
    setDefaultFilter(getDefaultFilterWithScope(nextTabIndex, nextAccountId));
    setDefaultSearchFilter(
      getDefaultSearchFilterWithScope(nextTabIndex, nextAccountId),
    );
    listContext.setSort(getSortByWithScope(nextAccountId), "DESC");
    listContext.setPage(1);
    const nextFilterValues = listContext.filterValues || {};
    listContext.setFilters(
      { ...nextFilterValues },
      listContext.displayedFilters,
    );
  };

  const handleTabChange = (value) => {
    debugger;
    setTabIndex(value);
    applyScopedDefaults(value, selectedAccountId);
  };

  const handleAccountChange = (selectedAccount) => {
    const nextAccountId = selectedAccount?.id || null;
    setSelectedAccountId(nextAccountId);
    if (nextAccountId) {
      localStorage.setItem(accountStorageKey, nextAccountId);
    } else {
      localStorage.removeItem(accountStorageKey);
    }
    applyScopedDefaults(tabIndex, nextAccountId);
  };

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="Invoices" />} />
      <InvoiceListToolbar
        {...props}
        filters={getListFilters(mdDown, tabIndex)}
        actions={<ListActions xsDown={xsDown} />}
        xsDown={xsDown}
        selectedAccountId={selectedAccountId}
        onAccountChange={handleAccountChange}
      />
      <Card
        className={classnames(
          classes.listRoot,
          { [classes.bulkActions]: listContext.selectedIds.length > 0 },
          // [classes.bulkActions] remove to restore original behavior
        )}
      >
        <BulkActionsToolbar>
          <BulkListActions tabIndex={tabIndex} />
        </BulkActionsToolbar>
        <InvoiceTabs
          {...props}
          {...listContext}
          selectedAccountId={selectedAccountId}
          tabValue={tabIndex}
          setTabValue={handleTabChange}
          xsDown={xsDown}
          mdDown={mdDown}
        />
        <PaginationToolbar {...props} />
      </Card>
    </ListContextProvider>
  );
};

const PaginationToolbar = (props) => {
  const classes = useStyles();
  const listContext = useListContext(props);

  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  const [totals, setTotals] = useState({ subtotal: 0, tax: 0, total: 0 });

  useEffect(() => {
    debugger;
    if (listContext?.ids?.length > 0 && listContext?.data) {
      let subtotal = 0,
        tax = 0,
        total = 0;

      listContext.ids?.forEach((id) => {
        subtotal += listContext.data[id].subtotal;
        tax += listContext.data[id].tax;
        total += listContext.data[id].total;
      });

      setTotals({ subtotal, tax, total });
    }
  }, [listContext]);

  return (
    <Grid container direction="row" spacing={1} alignItems="center">
      <Hidden mdDown>
        <Grid item nd={5} lg={5}>
          <Typography className={classes.totals}>
            {`SUBTOTAL: ${formatter.format(
              totals.subtotal,
            )}, TAX: ${formatter.format(totals.tax)}, TOTAL: ${formatter.format(
              totals.total,
            )}`}
          </Typography>
        </Grid>
      </Hidden>
      <Grid item xs={12} md={7}>
        <Pagination {...props} {...listContext} />
      </Grid>
    </Grid>
  );
};

const InvoiceTabs = ({
  selectedAccountId,
  tabValue,
  setTabValue,
  setPage,
  ...props
}) => {
  const { xsDown } = props;

  const handleChange = (event, value) => {
    sessionStorage.setItem("InvoicesTab", value);
    setPage(1);
    setTabValue(value);
  };

  return (
    <>
      <Tabs
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {tabs.map(
          (itm, idx) =>
            (!xsDown || itm.showSmall) && (
              <Tab key={itm.id} label={itm.name} id={`invoice-${idx}`} />
            ),
        )}
      </Tabs>
      <Divider />
      {tabs.map(
        (itm) =>
          itm.id === tabs[tabValue].id && (
            <InvoiceGrid
              {...props}
              key={itm.id}
              selectedAccountId={selectedAccountId}
              tabValue={itm.id}
            />
          ),
      )}
    </>
  );
};

const InvoiceGrid = ({ ids, page, selectedAccountId, tabValue, ...props }) => {
  const { xsDown, mdDown } = props;
  const hasBulkActions = true;

  if (tabValue === InvoiceStatus.NEW && ids.length === 0 && page === 1)
    return <Empty {...props} message="Create a new invoice" />;
  else
    return xsDown ? (
      <SimpleList
        primaryText={(record) =>
          record.account?.displayName ?? record.accountName
        }
        secondaryText={(record) =>
          `Invoice No: ${record.invoiceNumber} - Due: ${new Date(
            record.dueDate,
          ).toLocaleDateString()}`
        }
        tertiaryText={(record) =>
          record.total.toLocaleString(undefined, {
            style: "currency",
            currency: "USD",
          })
        }
        leftIcon={(record) => <InvoiceStatusIcon record={record} />}
        rightIcon={() => (
          <ChevronRightIcon
            fontSize="large"
            color="secondary"
            style={{ marginLeft: 40, marginTop: 10 }}
          />
        )}
        linkType="edit"
      />
    ) : mdDown ? (
      <Datagrid {...props} rowClick="edit" hasBulkActions={hasBulkActions}>
        <FunctionField
          source="accountName"
          label="Account"
          sortable={true}
          render={accountNameRenderer}
        />
        <NumberField
          source="total"
          label="Amount"
          sortable={true}
          options={{
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }}
        />
        {tabValue === InvoiceStatus.PENDING ? (
          <NumberField
            source="balance"
            label="Balance"
            sortable={false}
            options={{
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }}
          />
        ) : null}
        <InvoiceStatusIcon source="status" label="Status" sortable={false} />
        <TextField source="invoiceNumber" label="Invoice No." sortable={true} />
        {tabValue !== InvoiceStatus.PAID ? <MarkPaidButton /> : null}
      </Datagrid>
    ) : (
      <Datagrid
        {...props}
        rowClick="edit"
        hasBulkActions={hasBulkActions}
        expand={<InvoicePeak />}
      >
        <FunctionField
          source="accountName"
          label="Account"
          sortable={true}
          render={accountNameRenderer}
        />
        <NumberField
          source="total"
          label="Amount"
          sortable={true}
          options={{
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }}
        />
        {tabValue === InvoiceStatus.PENDING ? (
          <NumberField
            source="balance"
            label="Balance"
            sortable={false}
            options={{
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }}
          />
        ) : null}
        <DateField
          source="dueDate"
          sortable={true}
          sortBy={getSortByWithScope(selectedAccountId)}
        />
        <InvoiceStatusIcon source="status" label="Status" sortable={false} />
        {tabValue === InvoiceStatus.PAID ? (
          <DateField source="paidDate" label="Completed" sortable={true} />
        ) : null}
        {tabValue === InvoiceStatus.PENDING ||
        tabValue === InvoiceStatus.PAID ? (
          <DateField source="sentDate" label="Sent" sortable={true} />
        ) : null}
        <TextField source="poNumber" label="PO Number" sortable={true} />
        <TextField source="invoiceNumber" label="Invoice No." sortable={true} />
        {tabValue !== InvoiceStatus.PAID ? <MarkPaidButton /> : null}
        <EditButton />
      </Datagrid>
    );
};
